// extracted by mini-css-extract-plugin
module.exports =  {"spinner":"a10a3f92e9--spinner--uXgOG","circle-spin":"a10a3f92e9--circle-spin--HhIQz"};